// JsFromRoutes CacheKey 6367c9fbf253f6372956ee92e5810495
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  delete: /* #__PURE__ */ definePathHelper('get', '/expense_payments/:public_id/delete'),
  create: /* #__PURE__ */ definePathHelper('post', '/expense_payments'),
  new: /* #__PURE__ */ definePathHelper('get', '/expense_payments/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/expense_payments/:public_id/edit'),
  update: /* #__PURE__ */ definePathHelper('patch', '/expense_payments/:public_id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/expense_payments/:public_id'),
}
